var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-dependency-injection";
import * as Enumerable from "linq";
import { ManageBranchesClientService } from "../../../../services/manage/manage-branches.service";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import { BindingEngine } from "aurelia-binding";
import { UnitOfWorkObserver } from "../../../../utilities/unit-of-work-observer";
import { CacheClient } from "../../../../services/basics/client-caching.service";
import { DataType, ItemSource, SourceType } from "../../../../models/queries/queries.models";
import { computedFrom } from "aurelia-binding";
import { NotifyPropertyChangedBase, Reflection } from "../../../../utilities/reflection";
import { GenesisRouterConstants } from "../../../../configuration/router.constants";
import { Router } from "aurelia-router";
import { I18N } from 'aurelia-i18n';
import { PermissionEntity } from "../../../../models/manage/permissions.models";
import { DialogServiceConstants } from "../../../../constants/basics/dialog.constants";
import { GenesisLookups } from "../../../../constants/lookups/lookup.constants";
import { UserRoleAndClaimsHelper } from "../../../../helpers/user-role-and-claims.helper";
import { UserClientService } from "../../../../services/authentication/user-client.service";
var Branches = /** @class */ (function (_super) {
    __extends(Branches, _super);
    function Branches(manageBranchesService, notificationService, cacheService, dialogClient, router, engine, userClientService, i18N) {
        var _this = _super.call(this) || this;
        _this.manageBranchesService = manageBranchesService;
        _this.notificationService = notificationService;
        _this.cacheService = cacheService;
        _this.dialogClient = dialogClient;
        _this.router = router;
        _this.engine = engine;
        _this.userClientService = userClientService;
        _this.i18N = i18N;
        _this._branches = [];
        _this.isAnd = true;
        _this.page = 0;
        _this.pages = 1;
        _this.recordsPerPage = 10;
        _this.levels = [];
        return _this;
    }
    Branches.prototype.canAccessPermissions = function () {
        return UserRoleAndClaimsHelper.HasAccessPermissionsPagePermission(this.userClientService.currentUser.allowedClaims);
    };
    Branches.prototype.goToPermissions = function () {
        this.router.navigateToRoute(GenesisRouterConstants.RouteNames.ManagePermissions, {
            type: PermissionEntity.Branch,
            id: this.branchInEdit.branchId,
            name: this.branchInEdit.name
        });
    };
    Branches.prototype.goToValidations = function () {
        this.router.navigateToRoute(GenesisRouterConstants.RouteNames.ManageValidations, {
            type: PermissionEntity.Branch,
            id: this.branchInEdit.branchId,
            name: this.branchInEdit.name
        });
    };
    // branchSelected(event: Event) {
    //     if (event.srcElement.nodeName.toLowerCase() == "data-grid") {
    //         this.setBranch(event["detail"].item);
    //         this.rowSelected = event["detail"].row;
    //     }
    // }
    Branches.prototype.branchSelected = function (event) {
        var target = event.target;
        if (target && target.nodeName.toLowerCase() === 'data-grid') {
            this.setBranch(event.detail['item']);
            this.rowSelected = event.detail['row'];
        }
    };
    Branches.prototype.edit = function () {
        this.isEditCreate = true;
        this.branchInEdit.isEditable = true;
        if (this.rowSelected) {
            this.rowSelected.refresh();
        }
    };
    Object.defineProperty(Branches.prototype, "selectedBranchId", {
        get: function () {
            if (this._branches) {
                var open_1 = Enumerable.from(this._branches).firstOrDefault(function (x) { return x.isOpen; });
                if (open_1) {
                    return open_1.branchId;
                }
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Branches.prototype, "onlyOneSelected", {
        get: function () {
            if (this._branches && this.branchInEdit) {
                return true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Branches.prototype, "anyIsSelected", {
        get: function () {
            if (this._branches && this.branchInEdit) {
                return true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Branches.prototype.showDelete = function () {
        this.dialogClient.show(DialogServiceConstants.URLs.DeleteModal, this);
    };
    Object.defineProperty(Branches.prototype, "branches", {
        get: function () {
            var _this = this;
            var source = Enumerable.from(this._branches)
                .where(function (x) { return (!x.parentId && !_this.currentBranchId) ||
                x.parentId === _this.currentBranchId; })
                .toArray();
            return { source: source, sourceType: SourceType.Collection, columns: this.getColumns() };
        },
        enumerable: false,
        configurable: true
    });
    Branches.prototype.getColumns = function () {
        var _this = this;
        return [
            {
                sortOrder: 1,
                columnOrder: 1,
                name: "name",
                dataType: DataType.Default,
                title: this.i18N.tr('branch-name-text')
            },
            {
                sortOrder: 2,
                columnOrder: 2,
                name: "isActive",
                dataType: DataType.Boolean,
                title: this.i18N.tr('is-active-text')
            },
            {
                sortOrder: 3,
                columnOrder: 3,
                name: "showChildren",
                dataType: DataType.Icon,
                title: this.i18N.tr('children-text'),
                parameter: "navigate_next",
                value: function (x) {
                    _this.levels.push(x);
                    _this.currentBranchId = x.branchId;
                }
            },
            {
                sortOrder: 4,
                columnOrder: 4,
                name: "attachmentConfidentialityLevelId",
                dataType: DataType.Lookup,
                parameter: GenesisLookups.confidentialityLevels,
                title: this.i18N.tr('confidentiality-level')
            },
        ];
    };
    Branches.prototype.goToLevel = function (branch) {
        var index = this.levels.indexOf(branch);
        this.levels.splice(index, this.levels.length - index);
        this.currentBranchId = branch.parentId;
    };
    Object.defineProperty(Branches.prototype, "hasPervious", {
        get: function () {
            return this.page > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Branches.prototype, "hasNext", {
        get: function () {
            return this.page < this.pages - 1;
        },
        enumerable: false,
        configurable: true
    });
    Branches.prototype.activate = function () {
        this.getAllBranches();
    };
    Branches.prototype.setBranch = function (branch) {
        var _this = this;
        if (this.branchInEditUow) {
            if (this.branchInEdit && this.branchInEdit != branch) {
                this.isEditCreate = false;
                var changes_1 = this.branchInEditUow.getChanges();
                var keys = Object.keys(changes_1);
                keys.forEach(function (key) {
                    _this.branchInEdit[key] = changes_1[key].oldValue;
                });
                this.branchInEdit.isEditable = false;
                if (this.rowSelected) {
                    this.rowSelected.refresh();
                    this.rowSelected = null;
                }
                if (this.branchInEdit.branchId == 0) {
                    this.dataGridVm.removeRowByItem(this.branchInEdit);
                }
            }
            this.branchInEditUow.dispose();
        }
        this.branchInEdit = branch;
        if (this.branchInEdit) {
            this.branchInEditUow = UnitOfWorkObserver.getTrackingInstance(this.engine, this.branchInEdit);
        }
        if (this.branchInEdit && !this.branchInEdit.branchId) {
            setTimeout(function () {
                var currentBranchId = _this.currentBranchId;
                _this.branchInEditUow.addChange('isActive', true, false);
                _this.branchInEditUow.addChange('isDefault', false, null);
                _this.branchInEditUow.addChange('parentId', currentBranchId, null);
            });
        }
    };
    Branches.prototype.getEmptyBranch = function () {
        return {
            isActive: false,
            isOpen: true,
            isSelected: false,
            branchId: 0,
            parentId: null,
            managerId: null,
            branchRegionId: null,
            name: "",
            image: "",
            permissions: [],
            departments: [],
            users: [],
            isDefault: null
        };
    };
    Branches.prototype.newBranch = function () {
        var branch = this.getEmptyBranch();
        this.dataGridVm.selectedRow = this.dataGridVm.addNewRow(branch);
        this.edit();
    };
    Branches.prototype.onEnter = function ($event) {
        if ($event.detail && $event.detail.keyCode == 13) {
            this.search();
        }
    };
    Branches.prototype.save = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // validation: missing branch name
            if (Enumerable.from(_this._branches).any(function (x) { return !x.name; })) {
                _this.notificationService.show(_this.i18N.tr('validation-error-text'), _this.i18N.tr('branch-name-required-text'), NotificationType.Error);
                resolve();
                return;
            }
            // nothing to save
            if (!_this.branchInEditUow.hasChanges()) {
                resolve();
                return;
            }
            _this.manageBranchesService.save({
                changes: _this.branchInEditUow.getChanges(),
                id: _this.branchInEdit.branchId
            })
                .then(function (x) {
                // cache bust
                _this.cacheService.removeKeyContains('branches');
                _this.cacheService.removeKeyContains('roles');
                _this.cacheService.removeKeyContains('departments');
                // set new id if created
                if (!_this.branchInEdit.branchId && (x === null || x === void 0 ? void 0 : x.branch)) {
                    _this.branchInEdit.branchId = x.branch.branchId;
                }
                // refresh UI then resolve
                _this.search(function () {
                    _this.notificationService.show(_this.i18N.tr('successfully-saved-text'), _this.i18N.tr('branch-has-been-successfully-saved-text'), NotificationType.Success);
                    resolve();
                });
            })
                .catch(function (err) {
                _this.notificationService.show(_this.i18N.tr('error-text') + '!', _this.i18N.tr('branch-cannot-be-saved-text'), NotificationType.Error);
                reject(err instanceof Error ? err : new Error('Save failed'));
            });
        });
    };
    Branches.prototype.delete = function () {
        var _this = this;
        this.manageBranchesService.deleteBranch({
            branchIds: [this.branchInEdit.branchId]
        }).then(function (x) {
            _this.dialogClient.hide();
            _this.notificationService.show(_this.i18N.tr('successfully-deleted-text'), _this.i18N.tr('branch-has-been-successfully-deleted-text'), NotificationType.Success);
            _this.search();
        })
            .catch(function (x) {
            _this.notificationService.show(_this.i18N.tr('warning') + "!", _this.i18N.tr('branch-cannot-be-deleted-in-use-text'), NotificationType.Warning);
        });
    };
    Branches.prototype.search = function (actionAfterSearch) {
        if (actionAfterSearch === void 0) { actionAfterSearch = null; }
        this.branchInEdit = null;
        this.page = 0;
        this.getAllBranches(actionAfterSearch);
    };
    Branches.prototype.next = function () {
        this.page = this.page + 1;
        this.getAllBranches();
        this.isEditCreate = false;
    };
    Branches.prototype.pervious = function () {
        this.page = this.page - 1;
        this.getAllBranches();
        this.isEditCreate = false;
    };
    Branches.prototype.getAllBranches = function (actionAfterGet) {
        var _this = this;
        if (actionAfterGet === void 0) { actionAfterGet = null; }
        this.manageBranchesService.getAllBranches({
            searchText: this.searchText,
            isAnd: this.isAnd,
            page: this.page,
            recordsPerPage: this.recordsPerPage
        }).then(function (x) {
            _this.pages = x.pages ? x.pages : 1;
            _this._branches = x.branches;
            _this.isEditCreate = false;
            if (actionAfterGet) {
                actionAfterGet();
            }
        });
    };
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x._branches; }), Reflection.getPropertyPath(function (x) { return x.currentBranchId; }), Reflection.getPropertyPath(function (x) { return x.changes.branches; })),
        __metadata("design:type", ItemSource),
        __metadata("design:paramtypes", [])
    ], Branches.prototype, "branches", null);
    Branches = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ManageBranchesClientService,
            NotificationClientService,
            CacheClient,
            DialogClientService,
            Router,
            BindingEngine,
            UserClientService,
            I18N])
    ], Branches);
    return Branches;
}(NotifyPropertyChangedBase));
export { Branches };
